import React from "react";
import Icon from "../Icon";
import { EmptyState } from "../State";

export function IncidentsPanel({ incidents }) {
  if (!incidents || !incidents.length)
    return (
      <EmptyState
        icon="activity"
        title="No linked incidents"
        subtitle="No incidents linked to this ticket."
      />
    );

  const SEV_STYLES = {
    critical: { bg: "#FEF2F2", border: "#FEE2E2", text: "#991B1B", indicator: "#EF4444" },
    high: { bg: "#FFF7ED", border: "#FED7AA", text: "#9A3412", indicator: "#F97316" },
    medium: { bg: "#FEFCE8", border: "#FEF08A", text: "#713F12", indicator: "#EAB308" },
    low: { bg: "#F0FDF4", border: "#DCFCE7", text: "#166534", indicator: "#22C55E" },
  };

  const STATE_STYLES = {
    detected: { bg: "#EFF6FF", text: "#1E40AF", border: "#DBEAFE" },
    active: { bg: "#EFF6FF", text: "#1E40AF", border: "#DBEAFE" },
    suppressed: { bg: "#F3F4F6", text: "#374151", border: "#E5E7EB" },
    resolved: { bg: "#ECFDF5", text: "#065F46", border: "#D1FAE5" },
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {incidents.map((inc) => {
        const sevStyle = SEV_STYLES[inc.severity?.toLowerCase()] || {
          bg: "#F9FAFB",
          border: "#E5E7EB",
          text: "#374151",
          indicator: "#9CA3AF",
        };
        const stateStyle = STATE_STYLES[inc.state?.toLowerCase()] || {
          bg: "#F9FAFB",
          text: "#374151",
          border: "#E5E7EB",
        };

        return (
          <div
            key={inc.id}
            style={{
              background: "#FFFFFF",
              border: "1px solid #E2E8F0",
              borderLeft: `4px solid ${sevStyle.indicator}`,
              borderRadius: 8,
              padding: "12px 14px",
              boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.02)",
              display: "flex",
              flexDirection: "column",
              gap: 10,
            }}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Icon name="activity" size={13} color="#64748B" />
                <span
                  style={{
                    fontFamily: "var(--font-mono, monospace)",
                    fontSize: 11,
                    fontWeight: 600,
                    color: "#475569",
                    whiteSpace: "nowrap",
                  }}
                >
                  {inc.id}
                </span>
              </div>
              <div style={{ display: "flex", gap: 6 }}>
                {/* Severity Badge */}
                <span
                  style={{
                    fontSize: 10,
                    fontWeight: 600,
                    background: sevStyle.bg,
                    color: sevStyle.text,
                    border: `1px solid ${sevStyle.border}`,
                    padding: "2px 8px",
                    borderRadius: 12,
                    textTransform: "capitalize",
                  }}
                >
                  {inc.severity}
                </span>
                {/* State Badge */}
                <span
                  style={{
                    fontSize: 10,
                    fontWeight: 600,
                    background: stateStyle.bg,
                    color: stateStyle.text,
                    border: `1px solid ${stateStyle.border}`,
                    padding: "2px 8px",
                    borderRadius: 12,
                    textTransform: "capitalize",
                  }}
                >
                  {inc.state}
                </span>
              </div>
            </div>

            {/* Content Details */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                gap: 8,
                fontSize: 11.5,
                color: "#64748B",
                borderTop: "1px solid #F1F5F9",
                paddingTop: 8,
              }}
            >
              {inc.server_id && (
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  <Icon name="server" size={11} color="#94A3B8" />
                  <span>
                    Server ID: <strong style={{ color: "#334155", fontFamily: "monospace", whiteSpace: "nowrap" }}>{inc.server_id}</strong>
                  </span>
                </div>
              )}
              {inc.detected_at && (
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  <Icon name="clock" size={11} color="#94A3B8" />
                  <span>
                    Detected: <strong style={{ color: "#334155" }}>{new Date(inc.detected_at).toLocaleString()}</strong>
                  </span>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default IncidentsPanel;
